import React from 'react';
import { useRouter } from 'next/router';
import { Icon } from '../Icon';
import BackIcon from '../../public/static/images/item/arrow-right.svg';
import { useClient } from '../../hooks/useClient';
import { useGoBack } from '../../hooks/useGoBack';
import { BackButtonWrapper, BackButtonIconWrapper } from './styled';

interface BackButtonProps {
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  width?: number;
  height?: number;
}

export const BackButton: React.FC<BackButtonProps> = ({
  icon: IconComponent = BackIcon,
  width = 10,
  height = 16
}) => {
  const router = useRouter();
  const isClient = useClient();
  const goBack = useGoBack();

  if (!isClient) return null;

  const handleHistoryBack = () => {
    if (!goBack()) return;

    router.beforePopState(({ url }) => {
      if (url.includes('#')) {
        window.history.go(-2);
        return false;
      }
      return true;
    });
  };

  return (
    <BackButtonWrapper
      data-cy="back-button"
      role="button"
      aria-label="Back"
      tabIndex={0}
      onKeyPress={handleHistoryBack}
      onClick={handleHistoryBack}
    >
      <BackButtonIconWrapper>
        <Icon
          indent={false}
          IconComponent={IconComponent}
          width={width}
          height={height}
        />
      </BackButtonIconWrapper>
    </BackButtonWrapper>
  );
};
